module.exports = __webpack_public_path__ + "assets/img/c12.6474b4cb.png";